import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface CloseIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const CloseIcon: React.FC<CloseIconProps> = ({
  size = 16,
  color = 'iconPrimary',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Path d="M12 4L4 12" stroke={colors[color]} fill={colors[color]} />
      <Path d="M4 4L12 12" stroke={colors[color]} fill={colors[color]} />
    </Svg>
  );
};

CloseIcon.displayName = 'CloseIcon';
